export default {
  userId: ({ user }) => user && user.id,
  offers: ({ currentProductData }) => currentProductData.offers || [],
  userPhotoUrl: (state) => state.userPhotoUrl || 'assets/images/no-photo-user.jpg',
  isFromBrasil: (state) => state.user.locale?.toUpperCase() === 'PT_BR',
  userIsBumpInstallmentBeta: (state) => state.user.authorities?.includes?.('BUMP_INSTALLMENT'),
  userHasAccessToBumpInitialToggle: (state) => state.user.authorities?.includes?.('BUMP_FIRST_TOGGLE'),
  userLocale: (state) => state.user.locale?.toUpperCase()
}
